import * as React from 'react'
import { observer } from 'mobx-react'
import { ProductPrice, ProductQuantity, ProductTags, ProductSearchable, ProductQuantityInCart } from '../..'
import { IProduct } from '../../product.interfaces'
import './product-card-list.scss'
import { ProductImage } from '../../product-image'
import { cartStore } from '../../../cart'

interface IProps extends IProduct {
  openModal: VoidFunction
  displayUnavailable?: boolean
  hideMoreInfo?: boolean
  location?: string
}

@observer
export class ProductCardList extends React.Component<IProps> {
  render(): React.ReactNode {
    const baseClass: string = 'product-card-list'
    const { featuredImage, sku, tags, name, price, compareAtPrice, hideMoreInfo, images, id, location } = this.props

    return (
      <div className={baseClass}>
        <ProductImage
          tags={this.props.tags}
          imageUrl={featuredImage}
          onClick={this.props.openModal}
          secondaryImage={images?.[1]}
          baseClassName={baseClass}
          cart={true}
        />

        <div className={`${baseClass}__details`}>
          {location == 'cart' && cartStore.isProductNotAvailable(id) && (
            <div className={`${baseClass}__not-in-menu`}>
              <p>
                This product is not available for delivery on the delivery date you have chosen. Please remove and replace the product with
                a product from the menu in that week.
              </p>
            </div> 
          )}
          <ProductSearchable className={`${baseClass}__name`} content={name} />
          <ProductSearchable className={`${baseClass}__sku`} content={sku} />
          {!hideMoreInfo && (
            <div className={`${baseClass}__more-info`}>
              <a onClick={this.props.openModal}>More info</a>
            </div>
          )}
          <div className={`${baseClass}__labels`}>
            <ProductTags className={`${baseClass}__tags`} tags={tags} />
          </div>
        </div>
        <div className={`${baseClass}__purchase`}>
          <ProductPrice className={`${baseClass}__price`} price={price} compareAtPrice={compareAtPrice} />
          <div className={`${baseClass}__actions`}>
            {location === 'cart' ? (
              <ProductQuantityInCart {...this.props} className='list' />
            ) : (
              <ProductQuantity {...this.props} className='list' />
            )}
          </div>
        </div>
      </div>
    )
  }
}
